import React, { Component } from "react";

// STYLES
import styled from "styled-components";
import Colors from "../../../shared/colors"

export default class TextArea extends Component {
    render() {
        const {
            id,
            name,
            keyName,
            title,
            required,
            placeholder,
            min,
            max,
            error,
            success,
            message,
            onBlur
        } = this.props;

        return(
            <ApplyContent>
                {
                    title != null &&
                        <Title>
                            {title}
                            {
                                required && 
                                    '*'
                            }
                        </Title>
                }
                <InputContent>
                    <textarea rows="4" cols="50" placeholder={placeholder}  onBlur={(event, _id, _keyName, _required, _name, _min, _max) => onBlur(event, id, keyName, required, name, min, max)}>

                    </textarea>
                </InputContent>
                {
                    error &&
                        <Error>
                            {message}
                        </Error>
                }
                {
                    success &&
                        <Success>
                            {message}
                        </Success>
                }
            </ApplyContent>
        )
    }
}

const ApplyContent = styled.div `
    margin-bottom: 25px;
`;

const Title = styled.div `
    color: hsl(0, 0%, 17%);
    font-family: "PT Sans";
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    margin-bottom: 8px;
`
const InputContent = styled.div `
    display: flex;
    align-items: center;

    div{
        color: #545454;
        width: 40px;
        text-align: center;
        margin-right: -40px;
        z-index: 10;
        margin-top: -3px;
    }

    textarea{
        width: calc(100% - 16px);
        color: #545454;
        font-family: "PT Sans";
        font-size: 14px;
        line-height: 18px;
        padding: 10px 8px;
        border-radius: 3px;
        border: 1px solid #E6EBEC;
        outline: none;
        margin-bottom: 3px;
        transition: all 0.3s ease;

        
        &:focus{
            border: 1px solid ${Colors.primary};
        }
    }
`
const Error = styled.div `
    font-family: "PT Sans";
    font-size: 13px;
    color: red;
    opacity: 0.8
`
const Success = styled.div `
    font-family: "PT Sans";
    font-size: 13px;
    color: green;
    opacity: 0.8;
`


// WEBPACK FOOTER //
// ./src/components/apply/textarea/textarea.js